import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Header from './layout/Header';
import Menu from './layout/Menu';
import Footer from './layout/Footer';

import Usuarios from '../src/components/usuarios/Index';
import CrearUsuario from '../src/components/usuarios/Crear';
import EditarUsuario from '../src/components/usuarios/Editar';

import Roles from '../src/components/roles/Index';
import CrearRol from '../src/components/roles/Crear';
import EditarRol from '../src/components/roles/Editar';

import DepartamentosCargue from '../src/components/departamentos_cargue/Index';
import CrearDepartamentoCargue from '../src/components/departamentos_cargue/Crear';
import EditarDepartamentoCargue from '../src/components/departamentos_cargue/Editar';

import MunicipiosCargue from '../src/components/municipios_cargue/Index';
import CrearMunicipioCargue from '../src/components/municipios_cargue/Crear';
import EditarMunicipioCargue from '../src/components/municipios_cargue/Editar';

import DepartamentosVisita from '../src/components/departamentos_visita/Index';
import CrearDepartamentoVisita from '../src/components/departamentos_visita/Crear';
import EditarDepartamentoVisita from '../src/components/departamentos_visita/Editar';

import MunicipiosVisita from '../src/components/municipios_visita/Index';
import CrearMunicipioVisita from '../src/components/municipios_visita/Crear';
import EditarMunicipioVisita from '../src/components/municipios_visita/Editar';

import DepartamentosComercializadores from '../src/components/departamentos_comercializadores/Index';
import CrearDepartamentoComercializadores from '../src/components/departamentos_comercializadores/Crear';
import EditarDepartamentoComercializadores from '../src/components/departamentos_comercializadores/Editar';

import MunicipiosComercializadores from '../src/components/municipios_comercializadores/Index';
import CrearMunicipioComercializadores from '../src/components/municipios_comercializadores/Crear';
import EditarMunicipioComercializadores from '../src/components/municipios_comercializadores/Editar';

import DepartamentosOperadores from './components/departamentos_operadores/Index';
import CrearDepartamentoOperadores from './components/departamentos_operadores/Crear';
import EditarDepartamentoOperadores from './components/departamentos_operadores/Editar';

import MunicipiosOperadores from '../src/components/municipios_operadores/Index';
import CrearMunicipioOperadores from '../src/components/municipios_operadores/Crear';
import EditarMunicipioOperadores from '../src/components/municipios_operadores/Editar';

import Operadores from '../src/components/operadores/Index';
import CrearOperador from '../src/components/operadores/Crear';
import EditarOperador from './components/operadores/Editar';

import Comercializadores from '../src/components/comercializadores/Index';
import CrearComercializador from '../src/components/comercializadores/Crear';
import EditarComercializador from './components/comercializadores/Editar';

import MenuConfiguracion from '../src/components/menuconfiguracion/Index';
import EditarConfiguracion from '../src/components/menuconfiguracion/Editar';
import AddConfiguracion from '../src/components/menuconfiguracion/Crear';

import Concesiones from '../src/components/concesiones/Index';
import CrearConcesion from '../src/components/concesiones/Crear';
import EditarConcesion from '../src/components/concesiones/Editar';

import Empresas from '../src/components/empresas/Index';
import CrearEmpresa from '../src/components/empresas/Crear';
import EditarEmpresa from '../src/components/empresas/Editar';

import Alcaldia from '../src/components/alcaldias/Index';
import CrearAlcaldia from '../src/components/alcaldias/Crear';
import EditarAlcaldia from '../src/components/alcaldias/Editar';

import Contribuyente from './components/contribuyentes/Index';
import CrearContribuyente from './components/contribuyentes/Crear';
import EditarContribuyente from './components/contribuyentes/Editar';

import TipoClientes from './components/tipo_clientes/Index';
import CrearTipoCliente from './components/tipo_clientes/Crear';
import EditarTipoCliente from './components/tipo_clientes/Editar';

import Tarifas from './components/tarifas/Index';
import CrearTarifa from './components/tarifas/Crear';
import EditarTarifa from './components/tarifas/Editar';

import TipoNovedades from './components/tipo_novedades/Index';
import CrearTipoNovedad from './components/tipo_novedades/Crear';
import EditarTipoNovedad from './components/tipo_novedades/Editar';

import EstadosSuministros from './components/estados_suministros/Index';
import CrearEstadoSuministro from './components/estados_suministros/Crear';
import EditarEstadoSuministro from './components/estados_suministros/Editar';

import TipoVisitas from './components/tipo_visitas/Index';
import CrearTipoVisita from './components/tipo_visitas/Crear';
import EditarTipoVisita from './components/tipo_visitas/Editar';

import TipoContratos from './components/tipo_contratos/Index';
import CrearTipoContrato from './components/tipo_contratos/Crear';
import EditarTipoContrato from './components/tipo_contratos/Editar';

import Capitulos from './components/capitulos/Index';
import CrearCapitulo from './components/capitulos/Crear';
import EditarCapitulo from './components/capitulos/Editar';

import UCAPS from './components/ucaps/Index';
import CrearUCAP from './components/ucaps/Crear';
import EditarUCAP from './components/ucaps/Editar';

import Materiales from './components/materiales/Index';
import CrearMaterial from './components/materiales/Crear';
import EditarMaterial from './components/materiales/Editar';

import Equipos from './components/equipos/Index';
import CrearEquipo from './components/equipos/Crear';
import EditarEquipo from './components/equipos/Editar';

import Cotizaciones from './components/cotizaciones/Index';
import CotizacionesMant from './components/cotizaciones/MantenimientoCotizacion';
import CrearCotizacion from './components/cotizaciones/Crear';
import EditarCotizacion from './components/cotizaciones/Editar';
import Contratos from './components/cotizaciones/Contratos';
import VerContrato from './components/cotizaciones/VerContrato';

import ListaTablas from '../src/components/MenuPrincipal/Index';
import Master from '../src/components/Master/Listar';

import Productos from '../src/components/productos/Index';
import CrearProductos from '../src/components/productos/Crear';
import EditarProductos from '../src/components/productos/Editar';

import Liquidaciones from './components/cargue_liquidaciones/Index';
import CargueLiquidaciones from './components/cargue_liquidaciones/Crear';

import OYMRI from './components/cargue_oym_ri/Index';
import CargueOYMRI from './components/cargue_oym_ri/Crear';

import Comercializadoras from './components/cargue_comercializadores/Index';
import CargueComercializadoras from './components/cargue_comercializadores/Crear';

import FactComercializadores from '../src/components/fact_comercializadores/Index';
import CrearFactComercializador from '../src/components/fact_comercializadores/Crear';
import EditarFactComercializador from './components/fact_comercializadores/Editar';

import FactOperadoresRed from '../src/components/fact_operadores/Index';
import CrearFactOperadorRed from '../src/components/fact_operadores/Crear';
import EditarFactOperadorRed from './components/fact_operadores/Editar';

import FactMunicipio from '../src/components/fact_municipio/Index';
import CrearFactMunicipio from '../src/components/fact_municipio/Crear';
import EditarFactMunicipio from './components/fact_municipio/Editar';

import FactAportesMunicipales from '../src/components/fact_aportes/Index';
import CrearFactAportesMunicipales from '../src/components/fact_aportes/Crear';
import EditarFactAportesMunicipales from './components/fact_aportes/Editar';

import ClientesEspeciales from './components/clientes_especiales/Index';
import CrearClienteEspecial from './components/clientes_especiales/Crear';
import EditarClienteEspecial from './components/clientes_especiales/Editar';

import RecaOperadoresRed from '../src/components/reca_operadores/Index';
import CrearRecaOperadorRed from '../src/components/reca_operadores/Crear';
import EditarRecaOperadorRed from './components/reca_operadores/Editar';

import RecaComercializadores from './components/reca_comercializadores/Index';
import CrearRecaComercializador from '../src/components/reca_comercializadores/Crear';
import EditarRecaComercializador from './components/reca_comercializadores/Editar';

import RecaMunicipio from '../src/components/reca_municipio/Index';
import CrearRecaMunicipio from '../src/components/reca_municipio/Crear';
import EditarRecaMunicipio from './components/reca_municipio/Editar';

import RecaAportesMunicipales from '../src/components/reca_aportes/Index';
import CrearRecaAportesMunicipales from '../src/components/reca_aportes/Crear';
import EditarRecaAportesMunicipales from './components/reca_aportes/Editar';

import ActasInterventoria from '../src/components/actas_interventoria/Index';
import CrearActasInterventoria from '../src/components/actas_interventoria/Crear';
import EditarActasInterventoria from './components/actas_interventoria/Editar';

import LiquidacionesInterventoria from '../src/components/liquidaciones_interventoria/Index';
import CrearLiquidacionesInterventoria from '../src/components/liquidaciones_interventoria/Crear';
import EditarLiquidacionesInterventoria from './components/liquidaciones_interventoria/Editar';

import BitacoraVisitas from '../src/components/bitacora_visitas/Index';
import CrearBitacoraVisita from '../src/components/bitacora_visitas/Crear';
import CargarBitacoraVisita from '../src/components/bitacora_visitas/Cargar';

import MunicipiosLibreta from '../src/components/municipios_libreta/Index';
import CrearMunicipioLibreta from '../src/components/municipios_libreta/Crear';
import EditarMunicipioLibreta from './components/municipios_libreta/Editar';

import PQR from '../src/components/pqr/Index';
import CrearPQR from '../src/components/pqr/Crear';
import EditarPQR from './components/pqr/Editar';

import EstadoCuentas from '../src/components/estado_cuentas/Index';
import ConsultarCartera from '../src/components/estado_cuentas/Consultar';
import GenerarEstadoCuentas from '../src/components/estado_cuentas/Crear';
import EditarEstadoCuentas from './components/estado_cuentas/Editar';

import TipoEtapas from './components/tipo_etapas/Index';
import CrearTipoEtapa from './components/tipo_etapas/Crear';
import EditarTipoEtapa from './components/tipo_etapas/Editar';

import TipoActuaciones from './components/tipo_actuaciones/Index';
import CrearTipoActuacion from './components/tipo_actuaciones/Crear';
import EditarTipoActuacion from './components/tipo_actuaciones/Editar';

import ConsultasBasicas from './components/consultas_basicas/Index';
import ReporteBalanceFlujo from  './components/balance_flujo/Index';
import ReporteBitacoraVisitas from './components/bitacora_visitas/Consultar';
import ReporteFactAportesMunicipales from './components/fact_aportes/Consultar';
import ReporteFactComercializadores from './components/fact_comercializadores/Consultar';
import ReporteFactMunicipio from './components/fact_municipio/Consultar';
import ReporteFactOperadoresRed from './components/fact_operadores/Consultar';
import ReportePQR from './components/pqr/Consultar';
import Categorias from './components/categorias/Index';
import CrearCategorias from './components/categorias/Crear';
import EditarCategorias from './components/categorias/Editar';

import Ipp from '../src/components/ipp/Index';
import CrearIpp from '../src/components/ipp/Crear';
import EditarIpp from './components/ipp/Editar';
import Home from './components/home/Index';
function App() {
  const ux = localStorage.getItem("username");
  return (
    
    <Router>
      {ux != null ? <Header /> : ''}
      {ux != null ? <Menu /> : ''}
      {ux != null ? <Route exact path="/" component={Home}></Route> :
        <Route exact path="/" component={Login}></Route>}

        <Route exact path="/pages/:id" component={ux != null ? Master : Login}></Route> 
        <Route exact path="/home" component={ux != null ? Home : Login}></Route> 
       <Route exact path="/MenuConfiguracion" component={ux != null ? MenuConfiguracion : Login}></Route> 
       <Route exact path="/EditarConfiguracion/:id" component={ux != null ? EditarConfiguracion : Login}></Route>
       <Route exact path="/AddConfiguracion" component={ux != null ? AddConfiguracion : Login}></Route>

       <Route exact path="/Tablas/:id" component={ux != null ? ListaTablas : Login}></Route> 

      <Route exact path="/MasterUsuarios" component={ux != null ? Usuarios : Login}></Route>
      <Route exact path="/AddUsuarios" component={ux != null ? CrearUsuario : Login}></Route>
      <Route exact path="/UpUsuarios/:id" component={ux != null ? EditarUsuario : Login}></Route>

      <Route exact path="/MasterRoles" component={ux != null ? Roles : Login}></Route>
      <Route exact path="/AddRoles" component={ux != null ? CrearRol : Login}></Route>
      <Route exact path="/UpRoles/:id" component={ux != null ? EditarRol : Login}></Route>
      
      <Route exact path="/MasterDepartamentosCargue" component={ux != null ? DepartamentosCargue : Login}></Route>
      <Route exact path="/AddDepartamentosCargue" component={ux != null ? CrearDepartamentoCargue : Login}></Route>
      <Route exact path="/UpDepartamentosCargue/:id" component={ux != null ? EditarDepartamentoCargue : Login}></Route>

      <Route exact path="/MasterMunicipiosCargue" component={ux != null ? MunicipiosCargue : Login}></Route>
      <Route exact path="/AddMunicipiosCargue" component={ux != null ? CrearMunicipioCargue : Login}></Route>
      <Route exact path="/UpMunicipiosCargue/:id" component={ux != null ? EditarMunicipioCargue : Login}></Route>

      <Route exact path="/MasterDepartamentosVisita" component={ux != null ? DepartamentosVisita : Login}></Route>
      <Route exact path="/AddDepartamentosVisita" component={ux != null ? CrearDepartamentoVisita : Login}></Route>
      <Route exact path="/UpDepartamentosVisita/:id" component={ux != null ? EditarDepartamentoVisita : Login}></Route>

      <Route exact path="/MasterMunicipiosVisita" component={ux != null ? MunicipiosVisita : Login}></Route>
      <Route exact path="/AddMunicipiosVisita" component={ux != null ? CrearMunicipioVisita : Login}></Route>
      <Route exact path="/UpMunicipiosVisita/:id" component={ux != null ? EditarMunicipioVisita : Login}></Route>

      <Route exact path="/MasterDepartamentosComercializadores" component={ux != null ? DepartamentosComercializadores : Login}></Route>
      <Route exact path="/AddDepartamentosComercializadores" component={ux != null ? CrearDepartamentoComercializadores : Login}></Route>
      <Route exact path="/UpDepartamentosComercializadores/:id" component={ux != null ? EditarDepartamentoComercializadores : Login}></Route>

      <Route exact path="/MasterMunicipiosComercializadores" component={ux != null ? MunicipiosComercializadores : Login}></Route>
      <Route exact path="/AddMunicipiosComercializadores" component={ux != null ? CrearMunicipioComercializadores : Login}></Route>
      <Route exact path="/UpMunicipiosComercializadores/:id" component={ux != null ? EditarMunicipioComercializadores : Login}></Route>

      <Route exact path="/MasterDepartamentosOperadores" component={ux != null ? DepartamentosOperadores : Login}></Route>
      <Route exact path="/AddDepartamentosOperadores" component={ux != null ? CrearDepartamentoOperadores : Login}></Route>
      <Route exact path="/UpDepartamentosOperadores/:id" component={ux != null ? EditarDepartamentoOperadores : Login}></Route>

      <Route exact path="/MasterMunicipiosOperadores" component={ux != null ? MunicipiosOperadores : Login}></Route>
      <Route exact path="/AddMunicipiosOperadores" component={ux != null ? CrearMunicipioOperadores : Login}></Route>
      <Route exact path="/UpMunicipiosOperadores/:id" component={ux != null ? EditarMunicipioOperadores : Login}></Route>

      <Route exact path="/MasterOperadores" component={ux != null ? Operadores : Login}></Route>
      <Route exact path="/AddOperador" component={ux != null ? CrearOperador : Login}></Route>
      <Route exact path="/UpOperadores/:id" component={ux != null ? EditarOperador : Login}></Route>

      <Route exact path="/MasterComercializadores" component={ux != null ? Comercializadores : Login}></Route>
      <Route exact path="/AddComercializador" component={ux != null ? CrearComercializador : Login}></Route>
      <Route exact path="/UpComercializadores/:id" component={ux != null ? EditarComercializador : Login}></Route>

      <Route exact path="/MasterConcesiones" component={ux != null ? Concesiones : Login}></Route>
      <Route exact path="/AddConcesiones" component={ux != null ? CrearConcesion : Login}></Route>
      <Route exact path="/UpConcesiones/:id" component={ux != null ? EditarConcesion : Login}></Route>

      <Route exact path="/MasterEmpresas" component={ux != null ? Empresas : Login}></Route>
      <Route exact path="/AddEmpresas" component={ux != null ? CrearEmpresa : Login}></Route>
      <Route exact path="/UpEmpresas/:id" component={ux != null ? EditarEmpresa : Login}></Route>

      <Route exact path="/MasterAlcaldias" component={ux != null ? Alcaldia : Login}></Route>
      <Route exact path="/AddAlcaldia" component={ux != null ? CrearAlcaldia : Login}></Route>
      <Route exact path="/UpAlcaldia/:id" component={ux != null ? EditarAlcaldia : Login}></Route>

      <Route exact path="/MasterContribuyentes" component={ux != null ? Contribuyente : Login}></Route>
      <Route exact path="/AddContribuyente" component={ux != null ? CrearContribuyente : Login}></Route>
      <Route exact path="/UpContribuyente/:id" component={ux != null ? EditarContribuyente : Login}></Route>

      <Route exact path="/MasterTipoClientes" component={ux != null ? TipoClientes : Login}></Route>
      <Route exact path="/AddTipoClientes" component={ux != null ? CrearTipoCliente : Login}></Route>
      <Route exact path="/UpTipoClientes/:id" component={ux != null ? EditarTipoCliente : Login}></Route>

      <Route exact path="/MasterTarifas" component={ux != null ? Tarifas : Login}></Route>
      <Route exact path="/AddTarifas" component={ux != null ? CrearTarifa : Login}></Route>
      <Route exact path="/UpTarifas/:id" component={ux != null ? EditarTarifa : Login}></Route>

      <Route exact path="/MasterTipoNovedades" component={ux != null ? TipoNovedades : Login}></Route>
      <Route exact path="/AddTipoNovedades" component={ux != null ? CrearTipoNovedad : Login}></Route>
      <Route exact path="/UpTipoNovedades/:id" component={ux != null ? EditarTipoNovedad : Login}></Route>

      <Route exact path="/MasterEstadosSuministros" component={ux != null ? EstadosSuministros : Login}></Route>
      <Route exact path="/AddEstadosSuministros" component={ux != null ? CrearEstadoSuministro : Login}></Route>
      <Route exact path="/UpEstadosSuministros/:id" component={ux != null ? EditarEstadoSuministro : Login}></Route>

      <Route exact path="/MasterTipoVisitas" component={ux != null ? TipoVisitas : Login}></Route>
      <Route exact path="/AddTipoVisitas" component={ux != null ? CrearTipoVisita : Login}></Route>
      <Route exact path="/UpTipoVisitas/:id" component={ux != null ? EditarTipoVisita : Login}></Route>

      <Route exact path="/MasterTipoContratos" component={ux != null ? TipoContratos : Login}></Route>
      <Route exact path="/AddTipoContratos" component={ux != null ? CrearTipoContrato : Login}></Route>
      <Route exact path="/UpTipoContratos/:id" component={ux != null ? EditarTipoContrato : Login}></Route>

      <Route exact path="/MasterCapitulos" component={ux != null ? Capitulos : Login}></Route>
      <Route exact path="/AddCapitulos" component={ux != null ? CrearCapitulo : Login}></Route>
      <Route exact path="/UpCapitulos/:id" component={ux != null ? EditarCapitulo : Login}></Route>

      <Route exact path="/MasterUCAPS" component={ux != null ? UCAPS : Login}></Route>
      <Route exact path="/AddUCAPS" component={ux != null ? CrearUCAP : Login}></Route>
      <Route exact path="/UpUCAPS/:id" component={ux != null ? EditarUCAP : Login}></Route>

      <Route exact path="/MasterMateriales" component={ux != null ? Materiales : Login}></Route>
      <Route exact path="/AddMateriales" component={ux != null ? CrearMaterial : Login}></Route>
      <Route exact path="/UpMateriales/:id" component={ux != null ? EditarMaterial : Login}></Route>

      <Route exact path="/MasterEquipos" component={ux != null ? Equipos : Login}></Route>
      <Route exact path="/AddEquipos" component={ux != null ? CrearEquipo : Login}></Route>
      <Route exact path="/UpEquipos/:id" component={ux != null ? EditarEquipo : Login}></Route>

      <Route exact path="/MasterCotizaciones" component={ux != null ? Cotizaciones : Login}></Route>
      <Route exact path="/MantenimientoCotizacion" component={ux != null ? CotizacionesMant : Login}></Route>
      <Route exact path="/AddCotizaciones" component={ux != null ? CrearCotizacion : Login}></Route>
      <Route exact path="/UpCotizaciones/:id" component={ux != null ? EditarCotizacion : Login}></Route>

      <Route exact path="/MasterContratos" component={ux != null ? Contratos : Login}></Route>
      <Route exact path="/VerContrato/:id" component={ux != null ? VerContrato : Login}></Route>

      <Route exact path="/MasterProductos" component={ux != null ? Productos : Login}></Route>
      <Route exact path="/AddProductos" component={ux != null ? CrearProductos : Login}></Route>
      <Route exact path="/UpProductos/:id" component={ux != null ? EditarProductos : Login}></Route>

      <Route exact path="/MasterCargueOYMRI" component={ux != null ? OYMRI : Login}></Route>
      <Route exact path="/AddCargueOYMRI" component={ux != null ? CargueOYMRI : Login}></Route>

      <Route exact path="/MasterCargueLiquidaciones" component={ux != null ? Liquidaciones : Login}></Route>
      <Route exact path="/AddCargueLiquidaciones" component={ux != null ? CargueLiquidaciones : Login}></Route>

      <Route exact path="/MasterCargueComercializadores" component={ux != null ? Comercializadoras : Login}></Route>
      <Route exact path="/AddCargueComercializador" component={ux != null ? CargueComercializadoras : Login}></Route>

      <Route exact path="/MasterFactComercializadores" component={ux != null ? FactComercializadores : Login}></Route>
      <Route exact path="/AddFactComercializador" component={ux != null ? CrearFactComercializador : Login}></Route>
      <Route exact path="/UpFactComercializadores/:id" component={ux != null ? EditarFactComercializador : Login}></Route>

      <Route exact path="/MasterFactOperadoresRed" component={ux != null ? FactOperadoresRed : Login}></Route>
      <Route exact path="/AddFactOperadorRed" component={ux != null ? CrearFactOperadorRed : Login}></Route>
      <Route exact path="/UpFactOperadoresRed/:id" component={ux != null ? EditarFactOperadorRed : Login}></Route>

      <Route exact path="/MasterFactMunicipio" component={ux != null ? FactMunicipio : Login}></Route>
      <Route exact path="/AddFactMunicipio" component={ux != null ? CrearFactMunicipio : Login}></Route>
      <Route exact path="/UpFactMunicipio/:id" component={ux != null ? EditarFactMunicipio : Login}></Route>

      <Route exact path="/MasterFactAportesMunicipales" component={ux != null ? FactAportesMunicipales : Login}></Route>
      <Route exact path="/AddFactAportesMunicipales" component={ux != null ? CrearFactAportesMunicipales : Login}></Route>
      <Route exact path="/UpFactAportesMunicipales/:id" component={ux != null ? EditarFactAportesMunicipales : Login}></Route>

      <Route exact path="/MasterClientesEspeciales" component={ux != null ? ClientesEspeciales : Login}></Route>
      <Route exact path="/AddClientesEspeciales" component={ux != null ? CrearClienteEspecial : Login}></Route>
      <Route exact path="/UpClientesEspeciales/:id" component={ux != null ? EditarClienteEspecial : Login}></Route>

      <Route exact path="/MasterRecaOperadoresRed" component={ux != null ? RecaOperadoresRed : Login}></Route>
      <Route exact path="/AddRecaOperadorRed" component={ux != null ? CrearRecaOperadorRed : Login}></Route>
      <Route exact path="/UpRecaOperadoresRed/:id" component={ux != null ? EditarRecaOperadorRed : Login}></Route>

      <Route exact path="/MasterRecaComercializadores" component={ux != null ? RecaComercializadores : Login}></Route>
      <Route exact path="/AddRecaComercializador" component={ux != null ? CrearRecaComercializador : Login}></Route>
      <Route exact path="/UpRecaComercializadores/:id" component={ux != null ? EditarRecaComercializador : Login}></Route>

      <Route exact path="/MasterRecaMunicipio" component={ux != null ? RecaMunicipio : Login}></Route>
      <Route exact path="/AddRecaMunicipio" component={ux != null ? CrearRecaMunicipio : Login}></Route>
      <Route exact path="/UpRecaMunicipio/:id" component={ux != null ? EditarRecaMunicipio : Login}></Route>

      <Route exact path="/MasterRecaAportesMunicipales" component={ux != null ? RecaAportesMunicipales : Login}></Route>
      <Route exact path="/AddRecaAportesMunicipales" component={ux != null ? CrearRecaAportesMunicipales : Login}></Route>
      <Route exact path="/UpRecaAportesMunicipales/:id" component={ux != null ? EditarRecaAportesMunicipales : Login}></Route>

      <Route exact path="/MasterActasInterventoria" component={ux != null ? ActasInterventoria : Login}></Route>
      <Route exact path="/AddActasInterventoria" component={ux != null ? CrearActasInterventoria : Login}></Route>
      <Route exact path="/UpActasInterventoria/:id" component={ux != null ? EditarActasInterventoria : Login}></Route>

      <Route exact path="/MasterLiquidacionesInterventoria" component={ux != null ? LiquidacionesInterventoria : Login}></Route>
      <Route exact path="/AddLiquidacionesInterventoria" component={ux != null ? CrearLiquidacionesInterventoria : Login}></Route>
      <Route exact path="/UpLiquidacionesInterventoria/:id" component={ux != null ? EditarLiquidacionesInterventoria : Login}></Route>

      <Route exact path="/MasterBitacoraVisitas" component={ux != null ? BitacoraVisitas : Login}></Route>
      <Route exact path="/AddBitacoraVisitas" component={ux != null ? CrearBitacoraVisita : Login}></Route>
      <Route exact path="/UploadBitacoraVisitas/:id" component={ux != null ? CargarBitacoraVisita : Login}></Route>

      <Route exact path="/MasterMunicipiosLibreta" component={ux != null ? MunicipiosLibreta : Login}></Route>
      <Route exact path="/AddMunicipiosLibreta" component={ux != null ? CrearMunicipioLibreta : Login}></Route>
      <Route exact path="/UpMunicipiosLibreta/:id" component={ux != null ? EditarMunicipioLibreta : Login}></Route>

      <Route exact path="/MasterPQR" component={ux != null ? PQR : Login}></Route>
      <Route exact path="/AddPQR" component={ux != null ? CrearPQR : Login}></Route>
      <Route exact path="/UpPQR/:id" component={ux != null ? EditarPQR : Login}></Route>

      <Route exact path="/MasterEstadoCuentas" component={ux != null ? EstadoCuentas : Login}></Route>
      <Route exact path="/ConsultarCartera" component={ux != null ? ConsultarCartera : Login}></Route>
      <Route exact path="/AddGenerarEstadoCuentas" component={ux != null ? GenerarEstadoCuentas : Login}></Route>
      <Route exact path="/UpEstadoCuentas/:id" component={ux != null ? EditarEstadoCuentas : Login}></Route>

      <Route exact path="/MasterTipoEtapas" component={ux != null ? TipoEtapas : Login}></Route>
      <Route exact path="/AddTipoEtapas" component={ux != null ? CrearTipoEtapa : Login}></Route>
      <Route exact path="/UpTipoEtapas/:id" component={ux != null ? EditarTipoEtapa : Login}></Route>
      
      <Route exact path="/MasterTipoActuaciones" component={ux != null ? TipoActuaciones : Login}></Route>
      <Route exact path="/AddTipoActuaciones" component={ux != null ? CrearTipoActuacion : Login}></Route>
      <Route exact path="/UpTipoActuaciones/:id" component={ux != null ? EditarTipoActuacion : Login}></Route>

      <Route exact path="/MasterConsultasIngreso" component={ux != null ? ConsultasBasicas : Login}></Route>
      <Route exact path="/MasterBalanceFlujo" component={ux != null ? ReporteBalanceFlujo : Login}></Route>
      <Route exact path="/MasterConsultasBitacoraVisitas" component={ux != null ? ReporteBitacoraVisitas : Login}></Route>
      <Route exact path="/MasterConsultasFactAportes" component={ux != null ? ReporteFactAportesMunicipales : Login}></Route>
      <Route exact path="/MasterConsultasFactComer" component={ux != null ? ReporteFactComercializadores : Login}></Route>
      <Route exact path="/MasterConsultasFactMun" component={ux != null ? ReporteFactMunicipio : Login}></Route>
      <Route exact path="/MasterConsultasFactOper" component={ux != null ? ReporteFactOperadoresRed : Login}></Route>
      <Route exact path="/MasterConsultasPQR" component={ux != null ? ReportePQR : Login}></Route>
  
    <Route exact path="/MasterCategorias" component={ux != null ? Categorias : Login}></Route>
    <Route exact path="/AddCategoria" component={ux != null ? CrearCategorias : Login}></Route>
      <Route exact path="/UpCategoria/:id" component={ux != null ? EditarCategorias : Login}></Route>

      <Route exact path="/AddTipoActuaciones" component={ux != null ? CrearTipoActuacion : Login}></Route>
      <Route exact path="/UpTipoActuaciones/:id" component={ux != null ? EditarTipoActuacion : Login}></Route>
    
      <Route exact path="/MasterIpp" component={ux != null ? Ipp : Login}></Route>
      <Route exact path="/AddIpp" component={ux != null ? CrearIpp : Login}></Route>
      <Route exact path="/UpIpp/:id" component={ux != null ? EditarIpp : Login}></Route>
      {ux != null ? <Footer /> : ''}
    </Router>
  );
}

export default App;
